import(/* webpackMode: "eager", webpackExports: ["LendingPageSkeleton"] */ "/vercel/path1/app/lending/components/LendingPage.skeleton.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path1/app/lending/LendingContent.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path1/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path1/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
